"use client";

import { useTranslations } from "next-intl";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/contexts/theme-context";

const ThemeToggleButton = () => {
  const t = useTranslations("footer");
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="flex h-11 items-center gap-2 rounded-full border border-white/40 bg-white/80 px-4 text-sm font-semibold text-brand-navy shadow-md backdrop-blur transition hover:-translate-y-0.5 hover:shadow-lg dark:border-white/15 dark:bg-surface-dark/80 dark:text-white"
      aria-label={isDark ? t("toggle_to_light") : t("toggle_to_dark")}
    >
      {isDark ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
      <span>{isDark ? t("dark") : t("light")}</span>
    </button>
  );
};

export default ThemeToggleButton;
